import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum InternalReferralSourcePalEnum {
    Hospice = 1 as number,
    Palliative = 2 as number
}
class InternalReferralSourcePalClass extends EnumWithDescription<InternalReferralSourcePalEnum> {
    public readonly enum = InternalReferralSourcePalEnum;
    public readonly enumName: string = "InternalReferralSourcePalEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<InternalReferralSourcePalEnum>> = new Map([
        [
            "Hospice",
            {
                value: InternalReferralSourcePalEnum.Hospice,
                name: "Hospice"
            }
        ],
        [
            "Palliative",
            {
                value: InternalReferralSourcePalEnum.Palliative,
                name: "Palliative Care"
            }
        ]
    ]);
}

export const InternalReferralSourcePal = new InternalReferralSourcePalClass();
